const STORAGE_KEY = 'arcadia.chunk_reload_at';
const COOLDOWN_MS = 12_000;

function isChunkLoadFailure(reason: unknown): boolean {
  const msg = reason instanceof Error ? reason.message : String(reason ?? '');
  const name = reason instanceof Error ? reason.name : '';
  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /Loading chunk [\w-]+ failed/i.test(msg) ||
    name === 'ChunkLoadError'
  );
}

/**
 * One automatic full reload when a code-split chunk fails to load (common after
 * deploy while an old tab still references removed hashed files). Cooldown prevents
 * tight reload loops if the asset is actually missing.
 */
export function installChunkErrorRecovery(): void {
  if (typeof window === 'undefined') return;

  const tryReload = (reason: unknown): boolean => {
    if (!isChunkLoadFailure(reason)) return false;
    const now = Date.now();
    const last = Number(sessionStorage.getItem(STORAGE_KEY) || '0');
    if (last && now - last < COOLDOWN_MS) return false;
    sessionStorage.setItem(STORAGE_KEY, String(now));
    window.setTimeout(() => window.location.reload(), 0);
    return true;
  };

  window.addEventListener('unhandledrejection', (ev) => {
    if (tryReload(ev.reason)) {
      ev.preventDefault();
    }
  });

  window.addEventListener('error', (ev) => {
    if (ev.error !== undefined && tryReload(ev.error)) {
      ev.preventDefault();
    }
  });
}
